(function () {
  'use strict';

  var BREAKPOINTS = [
    { mq: '(min-width: 1001px)', visible: 3 },
    { mq: '(min-width: 601px) and (max-width: 1000px)', visible: 2 },
    { mq: '(max-width: 600px)', visible: 1 },
  ];

  function getVisibleCount(root) {
    var desktop = parseInt(root.dataset.visibleDesktop, 10) || 3;
    var tablet = parseInt(root.dataset.visibleTablet, 10) || 2;
    var mobile = parseInt(root.dataset.visibleMobile, 10) || 1;

    if (window.matchMedia('(min-width: 1001px)').matches) {
      return desktop;
    }

    if (window.matchMedia('(min-width: 601px)').matches) {
      return tablet;
    }

    return mobile;
  }

  function getSlideElements(track) {
    return Array.prototype.slice.call(track.children);
  }

  function initCarousel(root) {
    var track = root.querySelector('.testi-grid');
    var prevButton = root.querySelector('.testi-carousel__nav--prev');
    var nextButton = root.querySelector('.testi-carousel__nav--next');
    var count = parseInt(root.dataset.testimonialCount, 10) || 0;

    if (!track || !prevButton || !nextButton || count === 0) {
      return;
    }

    function updateCarouselState() {
      var visible = getVisibleCount(root);
      var shouldCarousel = count > visible;

      root.classList.toggle('is-carousel', shouldCarousel);
      root.style.setProperty('--testi-visible', String(visible));

      prevButton.hidden = !shouldCarousel;
      nextButton.hidden = !shouldCarousel;
      prevButton.setAttribute('aria-hidden', shouldCarousel ? 'false' : 'true');
      nextButton.setAttribute('aria-hidden', shouldCarousel ? 'false' : 'true');

      if (!shouldCarousel) {
        track.scrollLeft = 0;
        track.removeAttribute('tabindex');
      } else {
        track.setAttribute('tabindex', '0');
      }
    }

    function scrollByPage(direction) {
      var visible = getVisibleCount(root);
      var slide = track.querySelector('[role="listitem"]');

      if (!slide) {
        return;
      }

      var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || '0');
      var distance = (slide.getBoundingClientRect().width + gap) * visible * direction;
      track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    prevButton.addEventListener('click', function () {
      scrollByPage(-1);
    });

    nextButton.addEventListener('click', function () {
      scrollByPage(1);
    });

    track.addEventListener('keydown', function (event) {
      if (!root.classList.contains('is-carousel')) {
        return;
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        scrollByPage(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        scrollByPage(1);
      }
    });

    updateCarouselState();
    window.addEventListener('resize', updateCarouselState, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var carousels = document.querySelectorAll('.testi-carousel');

    carousels.forEach(function (root) {
      initCarousel(root);
    });
  });
})();
